import React from 'react';
import {NoteBlock} from '../components.js';

class Container extends React.Component {
	constructor(props) {
		super(props);

		this.onClick = this.onClick.bind(this);
	}

	onClick(e) {
		const key = e.currentTarget.getAttribute('data-id');

		if(typeof this.props.titles[key].onClick === 'function') {
			e.stopPropagation();
			this.props.titles[key].onClick(this.props.titles[key].key);
		}

	}

	getNum(numStr) {
		var num = '';
		for(var w = 0; w !== numStr.length; w++) {
			if(!isNaN(parseInt(numStr[w]))) {
				num += numStr[w];
			}
			else {
				break;
			}
		}

		return parseInt(num);
	}

	render() {
		const width = this.props.size.width || 'auto';
		const height = this.props.size.height || 'auto';
		const bgColor = this.props.bgcolor;
		var moreClasses = this.props.moreClass || '';
		const moreTitleClasses = this.props.moreTitleClass || '';
		const onHeaderClick = this.props.onclick || undefined;

		var noteBlock = '';

		if(this.props.note) {
			noteBlock = (
				<NoteBlock note={this.props.note} />
			);
		}

		var widthNum = this.getNum(width);
		var heightNum = this.getNum(height);

		if(widthNum / heightNum >= 1.5) {
			moreClasses += ' Wide';
		}

		var containerTitles = [];
		var containerHeaderButton = (this.props.button) ? (<div className="Container-Header-Button"> {this.props.button} </div>) : '';

		for(var key = 0; key !== this.props.titles.length; key++) {
			var title = this.props.titles[key];

			var classes = "Container-Title";
			const extraClass = (this.props.titletype === "toggle" && title.selected === false) ? " Toggle Unselected" : (this.props.titles.length > 1) ? " Toggle" : "";
			classes += extraClass;
			classes += ' ' + moreTitleClasses;

			containerTitles.push((
				<div key={key} data-id={key} className={classes} onClick={this.onClick}>
					<div>{title.label}</div>
				</div>
				));
			if(key !== this.props.titles.length - 1) {
				containerTitles.push((
					<div key={key + "divider"} data-id={key + "divider"} className={'Divider'}></div>
					));
			}
		}

		const headerStyle = {
			backgroundColor: bgColor,
			backgroundImage: 'linear-gradient(to bottom, ' + bgColor + ' 40%, rgba(0,0,0,0.2) )'
		};

		var headerClass = '';

		if(this.props.nogradient) {
			delete headerStyle.backgroundImage;
			headerClass = ' HighlightModal';
		}

		return (
			<div className={"Container " + moreClasses} style={{width: width, height: height}}>
				<div className={"Container-Header" + headerClass} style={headerStyle} onClick={onHeaderClick} >
					{containerTitles}
					{containerHeaderButton}
				</div>
				{noteBlock}
				<div className="Container-Body" style={{width: '100%', height: (heightNum - 4) + "vmin"}}>
					{this.props.contents}
				</div>
				{this.props.append}
			</div>
		);
	}

}

class ContainerSort extends React.Component {

	constructor(props) {
		super(props);

		this.onHeaderClick = this.onHeaderClick.bind(this);

		this.onItemClick = this.onItemClick.bind(this);

		this.state = {sortedBy : this.props.sortedBy, sortOrder : this.props.sortOrder || "desc"};
	}

	onHeaderClick(e) {
		if(!e) return;

		var targ = e.target;
		const curSort = this.state.sortedBy; 
		const newSort = targ.getAttribute('sort-id');
		const defaultOrder = targ.getAttribute('sort-ord');

		if(curSort === newSort) {
			this.setState({sortOrder : ((this.state.sortOrder === "desc") ? "asc" : "desc")});
		}
		else {
			this.setState({sortedBy : newSort, sortOrder : defaultOrder});
		}

	}

	onItemClick(e) {
		if(!e) return;

		this.props.onClick(e);
	}

	render() {
		const width = this.props.size.width;
		const height = this.props.size.height;
		const bgColor = this.props.bgcolor;
		const sortKey = this.state.sortedBy; //Key for the sort function
		const orderMod = (this.state.sortOrder === "desc") ? -1 : 1; //This will reverse the sort function if set to descending v ascending
		var containerTitles = [];

		for(var key = 0; key !== this.props.titles.length; key++) {
			var title = this.props.titles[key];

			var classes = "Container-Title-Sort";
			const extraClass = (title.sortId === this.state.sortedBy) ? " Sorted-" + this.state.sortOrder : "";
			classes += extraClass;
			containerTitles.push((
				<th scope="col" className={classes} sort-id={title.sortId} key={title.sortId + 'header'} sort-ord={title.sortOrd} onClick={this.onHeaderClick}>
					{title.label}
				</th>
				));
		}

		var sortCompare = function(a, b) {
			//// This is for sorting the list of items ////
			var rValue = 0;
			if(a[sortKey] > b[sortKey]) rValue = 1;
			else if (a[sortKey] < b[sortKey]) rValue = -1;

			return rValue * orderMod;
		};

		var sortedList = this.props.list.sort(sortCompare); //Get that sorted list
		var tableContents = [];

		for(var tKey = 0; tKey !== sortedList.length; tKey++) {
			var listItem = sortedList[tKey];
			var tableRow = [];

			for(var dkey in this.props.titles) {
				var itemKey = this.props.titles[dkey].sortId;
				var itemValue = (itemKey === 'percentage') ? listItem[itemKey].toString().slice(0, (listItem[itemKey].toString().indexOf(".") + 3)) + '%' : listItem[itemKey];
				tableRow.push((
					<td className="Container-Column" key={listItem.id + itemKey}>{itemValue}</td>
					));
			}

			tableContents.push((
				<tr className="Container-Row" key={listItem.id} data-id={listItem.id} onClick={this.onItemClick} >
					{tableRow}
				</tr>
				));

		}

		const headerStyle = {
			backgroundColor: bgColor,
			backgroundImage: 'linear-gradient(to bottom, ' + bgColor + ' 40%, rgba(0,0,0,0.2) )'
		};

		return (
			<div className="Container Sort" style={{width: width, height: height}}>
				<table>
					<thead>
						<tr className="Container-Header-Sort" style={headerStyle}>
							{containerTitles}
						</tr>
					</thead>
					<tbody className="Container-Body">
						<tr className="Container-Row spacer"><td></td></tr>
						{tableContents}
					</tbody>
				</table>
			</div>
		);
	}
}







export {Container, ContainerSort};


